import { render, staticRenderFns } from "./GroupRegistSuccess.vue?vue&type=template&id=68ae7050&"
import script from "./GroupRegistSuccess.vue?vue&type=script&lang=js&"
export * from "./GroupRegistSuccess.vue?vue&type=script&lang=js&"
import style0 from "./GroupRegistSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports